export enum FacilityType {
  OTHER = "Other",
  SKILLED_NURSING_FACILITY = "Skilled Nursing Facility (SNF)",
  CLINIC = "Clinic",
  HOSPITAL = "Hospital",
  ER = "ER",
  URGENT_CARE = "Urgent Care",
  NICU = "NICU",
  THERAPY = "Therapy",
  HOME_HEALTH = "Home Health",
  HOSPICE = "Hospice",
  OFFICE = "Office",
  NICKLAUS_HOSPITAL = "Nicklaus Hospital",
  NICKLAUS_ER = "Nicklaus ER",
}

export const FACILITY_TYPE_PROMPT = `
The type of facility where care was delivered. Only set if clearly indicated in the document from the facility name, document header, or explicit labeling. When in doubt, leave null rather than guessing.
`;
